import React, { Component } from "react";
import { Modal } from "antd";
import {
  showErrorNotification,
  strings,
  showSuccessNotification
} from "../../helpers";
import {
  getWeeklyNews,
  deleteWeeklyNewsArticle,
  createWeeklyNews
} from "../../services";
import WeeklyNewsView from "./WeeklyNewsView";

const { confirm } = Modal;

export default class WeeklyStatusContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      articles: [],
      isProcessing: false
    };
  }

  componentDidMount() {
    this.handleFetchWeeklyNews();
  }

  /**
   * @function fetchDoctorsList
   * @description This function get doctors data
   */
  handleFetchWeeklyNews = () => {
    this.setState({
      isProcessing: true
    });
    getWeeklyNews()
      .then(response => {
        this.setState({
          isProcessing: false
        });
        if (response?.data?.data?.length > 0) {
          const articles = response.data.data;
          const updatedArticles = [];
          articles.map(article => {
            updatedArticles.push(article.attributes);
          });
          this.setState({ articles: updatedArticles });
        } else {
          this.setState({
            articles: []
          });
        }
      })
      .catch(() => {
        showErrorNotification(strings.error_msg);
        this.setState({
          newsTypes: [],
          states: [],
          cities: [],
          specialities: [],
          isProcessing: false
        });
      });
  };

  /**
   * @func moveToArticleUrl
   * @param record
   * @desc this will move the article url page on web
   *
   */
  moveToArticleUrl = record => {
    window.open(record.source_link, "_blank");
  };

  /**
   * @function deleteSelectedArticle
   * @description This function will delete selected article
   */
  deleteSelectedArticle = id => {
    const _this = this;
    confirm({
      okText: "Delete",
      title: "Are you sure you want to delete the selected news article?",
      content: "",
      onOk() {
        _this.setState({ isProcessing: true });
        deleteWeeklyNewsArticle(id)
          .then(response => {
            _this.setState({
              isProcessing: false
            });
            if (response.data.success) {
              showSuccessNotification("News Article deleted successfully.");
              _this.handleFetchWeeklyNews();
            } else {
              _this.setState({
                isProcessing: false
              });
            }
          })
          .catch(() => {
            showErrorNotification(strings.error_msg);
            _this.setState({ newsArticleList: [], isProcessing: false });
          });
      },
      onCancel() {}
    });
  };

  updateArticleOrder = articles => {
    this.setState({ articles });
  };

  saveUpdatedOrder = () => {
    const { articles } = this.state;
    const newsArticles = [];
    articles.map((article, index) => {
      newsArticles.push({
        id: article?.id,
        sequence: index + 1
      });
    });
    
    this.setState({ isProcessing: true });
    const params = {
      news_articles: newsArticles
    };
    createWeeklyNews(params)
      .then(response => {
        if (response?.data?.success) {
          this.setState({ selectedWeeklyNews: [] });
          showSuccessNotification("Weekly news sequence updated successfully");
          this.handleFetchWeeklyNews();
        } else {
          showErrorNotification(strings.error_msg);
        }
      })
      .finally(() => {
        this.setState({ isProcessing: false });
      });
  };

  render() {
    const { articles, isProcessing } = this.state;

    return (
      <>
        <WeeklyNewsView
          articles={articles}
          isProcessing={isProcessing}
          moveToArticleUrl={this.moveToArticleUrl}
          deleteSelectedArticle={this.deleteSelectedArticle}
          updateArticleOrder={this.updateArticleOrder}
          saveUpdatedOrder={this.saveUpdatedOrder}
        />
      </>
    );
  }
}
